<template>
    <base-modal :closable="closable" :scrollable="true" :adaptive="true" height="auto" width="100%" :max-width="800" classes="v--modal my-6" :name="modalName">
        <div class="p-4 lg:p-8">
             <div class="max-w-3xl mx-auto flex">
                <div class="w-full lg:w-2/3 mb-4 lg:my-8 flex flex-col justify-between lg:border-r lg:pr-8">
                    <div>
                        <div v-if="!hideHeader">
                            <h2 class="text-3xl leading-tight font-bold">{{ _('register_form_v3.headline') }}</h2>
                            <span class="mt-2 block text-sm font-bold">{{ _('register_form_v3.headline_sub') }}</span>
                        </div>

                        <div class="mt-8">

                            <register-form-version-three></register-form-version-three>

                        </div>
                    </div>
                    <div class="mt-8 flex items-center justify-between text-sm">
                        <span>
                            {{ _('register_form_v3.already_member_text') }}<br />
                            <a
                                class="text-primary-700 "
                                :href="getPath('login')"
                            >{{ _('register_form_v3.already_member_link') }}</a>
                        </span>
                        <span v-if="isSv" class="text-right">
                            {{ _('register_form_v3.business_text') }}<br />
                            <a
                                class="text-primary-700 "
                                :href="getPath('REGISTER_BUSINESS_URL')"
                            >{{ _('register_form_v3.business_link') }}</a>
                        </span>
                    </div>
                </div>

                <div class="hidden md:block ml-8">
                    <div class="my-8">

                        <h3 class="text-xl leading-normal font-extrabold">{{ _('sidebar_signup_usp.how_it_works.headline') }}</h3>
                            <iframe
                                class="mt-4"
                                :src="howItWorksVideoUrl"
                                width="100%"
                                height="200"
                                frameborder="0"
                                allowscriptaccess="always"
                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen></iframe>

                            <h3 class="mt-8 text-xl leading-normal font-extrabold">{{ _('sidebar_signup_usp.trustpilot.headline') }}</h3>

                            <div
                                ref="trustpilotModalWidget"
                                class="mt-4 trustpilot-widget"
                                :data-locale="trustpilotLocale"
                                data-template-id="54d0e1d8764ea9078c79e6ee"
                                :data-businessunit-id="trustpilotBusinessUnitId"
                                data-style-height="280px"
                                data-style-width="100%"
                                data-theme="light"
                                data-stars="5"
                            ></div>


                    </div>
                </div>
            </div>

        </div>
    </base-modal>
</template>

<script>

    import { mapMutations, mapGetters, mapState, mapActions } from 'vuex'

    export default {

        props: {

            hideHeader: {
                type: Boolean,
                default: false
            },
            closable: {
                type: Boolean,
                default: true,
            },
            trustpilotBusinessUnitId: {
                type: String
            },
            trustpilotLocale: {
                type: String
            },
        },

        data() {
            return {
                modalName: "register-modal"
            }
        },

        computed: {
            ...mapGetters('general', ['_', 'getPath', 'isSv']),

            ...mapState('modal', ['showModals']),

            ...mapMutations('modal', ['showModal']),

            isVisible() {
                return this.showModals[this.modalName];
            },

            howItWorksVideoUrl() {
                if (this.isSv) {
                    return 'https://www.youtube-nocookie.com/embed/S40H1nnnDXU';
                } else {
                    return 'https://www.youtube-nocookie.com/embed/hGe50sfPaSs';
                }
            },

            howItWorksVideoModalName() {
                if (this.isSv) {
                    return 'how-it-works-video-modal';
                } else {
                    return 'how-it-works-video-poland';
                }
            }
        },

        watch: {
            isVisible(isVisible, visible) {
                if (isVisible) {
                    this.initTrustpilot();
                }
            },
        },

        methods: {
            initTrustpilot() {
                setTimeout(() => { // Nexttick won't work here. Need to wait for element to load (?)
                    window.Trustpilot.loadFromElement(this.$refs.trustpilotModalWidget);
                }, 300);

            }
        }
    }
</script>
